import { apiRequest } from '@/api/client';
import type { TagRecord } from '@/types/api';

/** Site tags: names and colours for grouping sites. */
export const tagsApi = {
  list: () => apiRequest<TagRecord[]>('/tags'),

  create: (input: { name: string; color?: string }) => apiRequest<TagRecord>('/tags', { method: 'POST', body: input }),

  update: (id: string, input: { name?: string; color?: string }) =>
    apiRequest<TagRecord>(`/tags/${id}`, { method: 'PATCH', body: input }),

  /** The site count is the caller saying how many sites it knows it untags. */
  remove: (id: string, siteCount: number) =>
    apiRequest<{ ok: boolean }>(`/tags/${id}?siteCount=${siteCount}`, { method: 'DELETE' }),
};
